@if (!filter()) {
  <wr-banner status="info"
             [icon]="{ icon: 'search-outline', pack: 'eva' }"
             message="Filter wählen und auf „Suchen“ klicken, um Wartungstimer zu laden."></wr-banner>
} @else {
  <div class="building-list" [nbSpinner]="isLoading()" nbSpinnerSize="giant" nbSpinnerStatus="primary">
    @if (loadError()) {
      <wr-banner status="danger"
                 [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                 message="Die Wartungstimer konnten nicht geladen werden. Bitte erneut suchen."></wr-banner>
    } @else {
      @if (showNoResults()) {
        <wr-banner status="info"
                   [icon]="{ icon: 'info-outline', pack: 'eva' }"
                   message="Keine Wartungstimer für die gewählten Filter gefunden."></wr-banner>
      }
      @for (building of buildings(); track building.id) {
        <div class="building">
          <div class="building-name">{{ building.sectionText }}</div>
          <div class="maintenance-timer-list">
            @for (maintenanceTimer of maintenanceTimersGrouped()[building.id]; track maintenanceTimer.id) {
              <wr-maintenance-timer [maintenanceTimer]="maintenanceTimer"
                                    [buildingEquipmentId]="maintenanceTimer.buildingEquipment.id"
                                    [showEquipmentLink]="true"
                                    (update)="onUpdate($event)"
                                    (delete)="onDelete(maintenanceTimer)"></wr-maintenance-timer>
            }

            @if (canCreate()) {
              <div class="new-timer-button"
                   role="button"
                   tabindex="0"
                   (click)="addMaintenanceTimer.emit({buildingId: building.id})"
                   (keydown.enter)="addMaintenanceTimer.emit({buildingId: building.id})">
                <nb-icon icon="plus-outline" pack="eva"></nb-icon>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
}
